import request from '@/utils/request'

//获取验证码
export function captcha(params) {
  return request({
    url: '/backend/captcha',
    mockPath: '/captcha',
    method: 'get',
    params
  })
}

//登录
export function login(data) {
  return request({
    url: '/backend/login',
    mockPath: '/login',
    method: 'post',
    data
  })
}

//刷新令牌
export function refresh(rt) {
  return request({
    url: '/backend/refresh?rt=' + rt,
    mockPath: '/refresh',
    method: 'put',
    
  })
}

//获取用户信息
export function info(params) {
  return request({
    url: '/backend/info',
    mockPath: '/info',
    method: 'get',
    params
  })
}

//登出
export function logout() {
  return request({
    url: '/backend/logout',
    mockPath: '/submit',
    method: 'delete'
  })
}


//修改密码
export function modifyAccount(data) {
  return request({
    url: '/backend/modify-passwd' ,
    mockPath: '/submit',
    method: 'put',
    data
  })
}

//获取数据字典
// export function getDict(code) {
//   return request({
//     url: '/admin/dict/code/'+code,
//     mockPath: '/dictCode',
//     method: 'get',
//     params
//   })
// }
